import { TailwindColorOrString, tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { VariantColor } from '@repo/toolkit/colors'

import { LocaleKeys } from '../../../../locale/translation-types'

export enum CenterStatus {
  OPEN = 'OPEN',
  SENT_TO_LEC = 'SENT_TO_LEC',
  VALIDATED = 'VALIDATED'
}

type CenterStatusOption = {
  color: TailwindColorOrString
  background: TailwindColorOrString
  label: LocaleKeys
  variant: VariantColor
  activityLabel: LocaleKeys
  travelExpenseLabel: LocaleKeys
}

export const centerStatusMapping: Record<CenterStatus, CenterStatusOption> = {
  OPEN: {
    color: tailwindColors.red.DEFAULT,
    background: tailwindColors.red.light.DEFAULT,
    label: 'center.status.enum.OPEN.label',
    variant: 'blue',
    activityLabel: 'center.status.enum.OPEN.activity.label',
    travelExpenseLabel: 'center.status.enum.OPEN.travel.expense.label'
  },
  SENT_TO_LEC: {
    color: tailwindColors.orange.DEFAULT,
    background: tailwindColors.orange.light.DEFAULT,
    label: 'center.status.enum.SENT_TO_LEC.label',
    variant: 'warning',
    activityLabel: 'center.status.enum.SENT_TO_LEC.activity.label',
    travelExpenseLabel: 'center.status.enum.SENT_TO_LEC.travel.expense.label'
  },
  VALIDATED: {
    color: tailwindColors.green.DEFAULT,
    background: tailwindColors.green.light.DEFAULT,
    label: 'center.status.enum.VALIDATED.label',
    activityLabel: 'center.status.enum.VALIDATED.activity.label',
    variant: 'success',
    travelExpenseLabel: 'center.status.enum.VALIDATED.travel.expense.label'
  }
}
